const namespace = 'str/tag/';

const tagActionNames = {
  TAG_GET_LIST: `${namespace}TAG_GET_LIST`,
  TAG_GET_LIST_SUCCESS: `${namespace}TAG_GET_LIST_SUCCESS`,
  TAG_SELECTION: `${namespace}TAG_SELECTION`,
  TAG_SELECTION_FROM_URL: `${namespace}TAG_SELECTION_FROM_URL`,
  TAG_SELECTION_FROM_URL_SUCCESS: `${namespace}TAG_SELECTION_FROM_URL_SUCCESS`,
  UPDATE_FILTERS: `${namespace}UPDATE_FILTERS`,
  RESET_TAGS: `${namespace}RESET_TAGS`,
};

export default tagActionNames;
